export default "__VITE_ASSET__DhJKKP3u__";